import React from 'react';
import { injectIntl, WrappedComponentProps } from '@kyruus/intl';
import _round from 'lodash/round';

import { RATINGS_AND_REVIEWS } from '../../lib/constants';
import messages from '../../lib/messages';
import {
  SubRatingsContainer,
  SubRatingRow,
  RatingTitle,
  RatingStarValue,
  AvgMetricsReviewRatings
} from './styles';
import StarRating from './star-rating';

const SubRatings = ({
  subRatings,
  intl
}: {
  subRatings: { metric: string; average_rating: number }[];
} & WrappedComponentProps): React.ReactElement => {
  const mappedSubRatings = subRatings.map(({ metric, average_rating }) => {
    const roundedSubRating = _round(average_rating, 1);

    return (
      <SubRatingRow
        key={metric}
        aria-label={intl.formatMessage(messages.ariaMetricStarRatingsAverage, {
          metric: metric,
          rating: roundedSubRating
        })}
        role="img"
      >
        <RatingTitle>{metric}</RatingTitle>
        <RatingStarValue>
          <StarRating
            rating={roundedSubRating}
            starSize={RATINGS_AND_REVIEWS.SUBCATEGORY_STAR_SIZE}
            widthAccuracyCorrection={
              RATINGS_AND_REVIEWS.SUBCATEGORY_STARS_ACCURACY_CORRECTION_WIDTH
            }
          />
          <AvgMetricsReviewRatings>
            <span aria-hidden={true}>{roundedSubRating}</span>
          </AvgMetricsReviewRatings>
        </RatingStarValue>
      </SubRatingRow>
    );
  });

  return <SubRatingsContainer>{mappedSubRatings}</SubRatingsContainer>;
};

export default injectIntl(SubRatings);
